import { Button, Modal, type ModalProps } from "@shapr3d/frontend-lib";

import useTranslation from "../../../hooks/useTranslation";

export const NonAutoRenewingUpgradeModal: React.FC<Pick<ModalProps, "open" | "onClose">> = ({
  open,
  onClose,
}) => {
  const { t, m } = useTranslation();

  return (
    <Modal
      open={open}
      title={t(m.NonAutoRenewingUpgradeModal.Title)}
      size="small"
      onClose={onClose}
    >
      <p>{t(m.NonAutoRenewingUpgradeModal.Body)}</p>
      <Button onClick={onClose}>{t(m.NonAutoRenewingUpgradeModal.CloseButton)}</Button>
    </Modal>
  );
};
